
export function sanitizeForFirestore<T extends object>(obj: T): T {
  const sanitized = { ...obj } as any;
  Object.keys(sanitized).forEach(key => {
    if (sanitized[key] === undefined) {
      delete sanitized[key];
    } else if (sanitized[key] !== null && typeof sanitized[key] === 'object' && !Array.isArray(sanitized[key])) {
      sanitized[key] = sanitizeForFirestore(sanitized[key]);
    }
  });
  return sanitized;
}
